/* eslint-disable max-len */
// ==============================================
// ==================Import======================
// ==============================================

// ==================React Hooks===================

// ==================Style&IMG===================
import './style.scss';
import { Link } from 'react-router-dom';

// ==================Actions===================

function Redirect() {
  // ==================Hook===================

  return (
    <div className="redirect--container">
      <p className="redirect--container--paragraph">Hello</p>
      <p className="redirect--container--paragraph">You have been redirected to this page because you used the link <b>"{window.location.href}"</b>.
        Please update the link or your bookmark to <b>"{window.location.href.replace(window.location.hash, '')}"</b> and click on the button below to be redirected.
      </p>
      <p className="redirect--container--paragraph">Thank you,</p>

      <Link to={window.location.href.replace(window.location.hash, '')} className="redirect--container--btn" target="_blank">
        {window.location.href.replace(window.location.hash, '')}
      </Link>

    </div>

  );
}

export default Redirect;
